(function (global) {
  global.cryptography = {}

  /**
  * Возвращает подписываемые атрибуты для произвольных данных.
  *
  * @function WebAccess.services.cryptography.getSignableAttributes
  * @param  {string} content Подписываемые данные.
  * @param  {string} certificateIdBase64 Имя сертификата в кодировке base64.
  * @param  {string} pluginNameBase64 Имя плагина в кодировке base64.
  * @return {deferred} promise
  * @since 5.6.0.1000
  */
  global.cryptography.getSignableAttributes = function (content, certificateIdBase64, pluginNameBase64) {
    var d = $.Deferred();

    var service = "/api/Cryptography.asmx/GetSignableAttributes";
    var args = {
      "certificateIdBase64": certificateIdBase64,
      "pluginNameBase64": pluginNameBase64,
      "content": content
    }
    WA.SRV.call(service, args).done(function (res) {
      d.resolve(res);
    }).fail(function (res) {
      d.reject(res);
    });

    return d.promise();
  };

  /**
  * Формирует электронную подпись.
  *
  * @function WebAccess.services.cryptography.buildSignature
  * @param  {string} signingAttributes Подписываемые атрибуты.
  * @param  {string} signedAttributes Подписанные атрибуты.
  * @param  {string} certificateIdBase64 Имя сертификата в кодировке base64.
  * @param  {string} pluginNameBase64 Имя плагина в кодировке base64.
  * @return {deferred} promise
  * @since 5.6.0.1000
  */
  global.cryptography.buildSignature = function (signingAttributes, signedAttributes, certificateIdBase64, pluginNameBase64) {
    var d = $.Deferred();

    var service = "/api/Cryptography.asmx/BuildSignature";
    var args = {
      "certificateIdBase64": certificateIdBase64,
      "pluginNameBase64": pluginNameBase64,
      "signingAttributes": signingAttributes,
      "signedAttributes": signedAttributes
    }
    WA.SRV.call(service, args).done(function (res) {
      d.resolve(res);
    }).fail(function (res) {
      d.reject(res);
    });

    return d.promise();
  };

  /**
    * Проверяет достоверность электронной подписи.
    *
    * @method WebAccess.services.cryptography.verifySignature
    * @param  {string} content Подписываемый контент.
    * @param  {base64string} signature Электронная подпись.
    * @param  {base64string} pluginNameBase64 Имя плагина Агента веб-доступа для подписания.
	* @return {deferred} promise
    */
  global.cryptography.verifySignature = function (content, signature, pluginNameBase64) {
    var d = $.Deferred();

    var service = "/api/Cryptography.asmx/VerifySignature";
    var args = {
      "pluginNameBase64": pluginNameBase64,
      "content": content,
      "signatureBase64": signature
    }

    WA.SRV.call(service, args).done(function (res) {
      d.resolve(res);
    }).fail(function (res) {
      d.reject(res);
    });

    return d.promise();
  };

  /**
   * Подписывает произвольный строковый контент.
   *
   * @method WebAccess.services.cryptography.signContent
   * @param  {string} content Подписываемый контент
   * @param  {base64string} certificateIdBase64 ИД сертификата, которым будет подписан контент
   * @param  {base64string} pluginNameBase64 Имя плагина Агента веб-доступа для подписания
   * @param  {string} comment Комментарий к подписи
   * @param  {bool} isApprovingSign Признак утверждающей подписи
   * @param  {bool} isForSubstitute Признак подписания документа от имени замещаемого пользователя
   * @param  {string} substituteUserCode Код замещаемого пользователя. Параметр передается, если в параметре isForSubstitute установлено значение true
   * @param  {function} onSignedCallback Функция обратного вызова для подписания. В качестве параметра передается ответ от Агента веб-доступа
   * @param  {string} additionalInfo Дополнительная информация
   * @param  {base64string} pluginVersion Версия плагина Агента веб-доступа для подписания
   * @param  {tokenPinCode} tokenPinCode Пин-код токена, с помощью которого подписывается контент
   * @return {deferred} Deferred-объект с EDMS-объектом.
   */
  global.cryptography.signContent = function (content, certificateIdBase64, pluginNameBase64, comment, isApprovingSign,
  isForSubstitute, substituteUserCode, onSignedCallback, additionalInfo, pluginVersion, tokenPinCode) {
    var d = $.Deferred();

    WA.services.cryptography.getSignableAttributes(content, certificateIdBase64, pluginNameBase64).done(function (signableAttributes) {
      WA.agent.edms.signAttributes(signableAttributes, certificateIdBase64, pluginNameBase64, pluginVersion, comment, isApprovingSign, isForSubstitute, substituteUserCode, additionalInfo, tokenPinCode, onSignedCallback).done(function (response) {
        var signedAttributes = response.result;
        WA.services.cryptography.buildSignature(signableAttributes, signedAttributes, certificateIdBase64, pluginNameBase64).done(function (signatureBase64) {
            WA.services.cryptography.verifySignature(content, signatureBase64, pluginNameBase64).done(function (success) {
              if (success === true) {
                d.resolve(signatureBase64);
              } else {
                d.reject(L("SIGNATURE_IS_INVALID"));
              }
            }).fail(function (res) {
              d.reject(res);
            })
          }).fail(function (res) {
            d.reject(res);
          })
        }).fail(function (res) {
          d.reject(res.message);
        })
    }).fail(function (res) {
      d.reject(res);
    })

    return d.promise();
  };

})(window.WebAccess.services);


